// import { useMediaQuery } from "react-responsive";
export const toRupiah = (number) => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(number);
};

// export const isMobileDevice = useMediaQuery({
//   query: "(min-device-width: 480px)",
// });

// export const isTabletDevice = useMediaQuery({
//   query: "(min-device-width: 768px)",
// });

// export const isLaptop = useMediaQuery({
//   query: "(min-device-width: 1024px)",
// });

// export const isDesktop = useMediaQuery({
//   query: "(min-device-width: 1200px)",
// });

// export const isBigScreen = useMediaQuery({
//   query: "(min-device-width: 1201px )",
// });
export const generate_random_string = (length) => {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export function formatBytes(bytes, decimals = 2) {
  // 10000000 10 MB
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export const currencyParser = (val) => {
  try {
    // for when the input gets clears
    if (typeof val === "string" && !val.length) {
      val = "0.0";
    }

    // detecting and parsing between comma and dot
    var group = new Intl.NumberFormat("id-ID").format(1111).replace(/1/g, "");
    var decimal = new Intl.NumberFormat("id-ID").format(1.1).replace(/1/g, "");
    var reversedVal = val.replace(new RegExp("\\" + group, "g"), "");
    reversedVal = reversedVal.replace(new RegExp("\\" + decimal, "g"), ".");
    //  => 1232.21 €

    // removing everything except the digits and dot
    reversedVal = reversedVal.replace(/[^0-9.]/g, "");
    //  => 1232.21

    // appending digits properly
    const digitsAfterDecimalCount = (reversedVal.split(".")[1] || []).length;
    const needsDigitsAppended = digitsAfterDecimalCount > 2;

    if (needsDigitsAppended) {
      reversedVal = reversedVal * Math.pow(10, digitsAfterDecimalCount - 2);
    }

    return Number.isNaN(reversedVal) ? 0 : reversedVal;
  } catch (error) {
    console.error(error);
  }
};

export const currencyFormatter = (value) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(value);

// Helper function to convert UTM parameter names to Indonesian labels
export const getUTMLabelIndonesian = (utmKey) => {
  const utmLabels = {
    utm_source: "Sumber Traffic",
    utm_medium: "Media/Channel",
    utm_campaign: "Kampanye",
    utm_term: "Kata Kunci",
    utm_content: "Konten",
  };
  return utmLabels[utmKey] || utmKey;
};